import { RouteObject, createBrowserRouter } from 'react-router-dom';
import { ROUTES } from './constants';
import PublicRouter from './PublicRouter';
import AdminRouter from './AdminRouter';
import { Reserve } from '../pages/Reserve';
import { ErrorPage } from '../pages/ErrorPage';
import { Favourites } from '../pages/Favourites';
import { Reservations } from '../pages/Reservations';
import { CalendarPage } from '../pages/CalendarPage';
import { Login } from '../pages/Login';
import { Register } from '../pages/Register';
import { Details } from '../pages/Details';
import { ResourceDetails } from '../pages/ResourceDetails';
import Profile from '../pages/Profile/Profile';
import { Statistics } from '../pages/Statistics';
import { UsersList } from '../pages/UsersList';
import { AdminPanel } from '../pages/AdminPanel';
import { History } from '../pages/History/History';
import { ReservationList } from '../pages/ReservationList';
import AdminStatistics from '../pages/AdminStatistics/AdminStatistics';
import { Navigate } from 'react-router-dom';
import { ActivateAccount } from '../pages/ActivateAccount';
import { RecoverPWD } from '../pages/RecoverPWD';


export const routes: RouteObject[] = [
    {
        path: ROUTES.LOGIN,
        element: <Login />,
    },
    {
        path: ROUTES.REGISTER,
        element: <Register />,
    },
    {
        path: `${ROUTES.VALIDATE}`,
        element: <ActivateAccount />,
    },
    {
        path: `${ROUTES.RECOVER_PWD}`,
        element: <RecoverPWD />,
    },
    {
        path: ROUTES.HOME,
        element: <PublicRouter />,
        children: [
            { index: true, element: <Navigate to={ROUTES.RESERVE} /> },
            { path: `${ROUTES.RESERVE}`, element: <Reserve /> },
            { path: `${ROUTES.DETAILS}/:id`, element: <Details /> },
            { path: `${ROUTES.FAVORITES}`, element: <Favourites /> },
            { path: `${ROUTES.RESERVATIONS}`, element: <Reservations /> },
            { path: `${ROUTES.CALENDAR}`, element: <CalendarPage /> },
            { path: `${ROUTES.PROFILE}`, element: <Profile /> },
            { path: `${ROUTES.HISTORY}`, element: <History /> },
            { path: `${ROUTES.STATISTICS}`, element: <Statistics /> },
            { path: `${ROUTES.ERROR}`, element: <ErrorPage isAdmin={false} /> },
            { path: "*", element: <ErrorPage isAdmin={false} /> },
        ]
    },
    {
        path: ROUTES.ADMIN,
        element: <AdminRouter />,
        children: [
            { index: true, element: <Navigate to={ROUTES.ADMIN + ROUTES.PANEL} /> },
            { path: `${ROUTES.ADMIN}${ROUTES.PANEL}`, element: <AdminPanel /> },
            { path: `${ROUTES.ADMIN}${ROUTES.RESOURCE_BY_ID}/:id`, element: <ResourceDetails /> },
            { path: `${ROUTES.ADMIN}${ROUTES.ADMIN_RESERVATIONS}`, element: <ReservationList /> },
            { path: `${ROUTES.ADMIN}${ROUTES.FAVORITES}`, element: <Favourites /> },
            { path: `${ROUTES.ADMIN}${ROUTES.STATISTICS}`, element: <AdminStatistics /> },
            { path: `${ROUTES.ADMIN}${ROUTES.USERS}`, element: <UsersList /> },
            { path: `${ROUTES.ADMIN}${ROUTES.PROFILE}`, element: <Profile /> },
            { path: `${ROUTES.ADMIN}${ROUTES.ERROR}`, element: <ErrorPage isAdmin={true} /> },
            { path: "*", element: <ErrorPage isAdmin={true} /> },
        ]
    }
]

export const router = createBrowserRouter(routes);